import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import type { PricingIndex } from '@/api/services/settings/pricing-indices.service';

import * as styles from './PricingIndicesTable.css';

type PricingIndicesTableProps = {
  columns: any[];
  data: PricingIndex[];
  isLoading: boolean;
};

export default function PricingIndicesTable({ columns, data, isLoading }: PricingIndicesTableProps) {
  const { t } = useTranslation();
  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        <TradingDatagrid
          tableHeight="calc(100vh - 280px)"
          columnsTable={columns}
          dataTable={data}
          flexLayout
          keepSelectedRowsOnPageChange={false}
          columnOrder={[]}
          stickyColumns={{
            edit: 'right',
            delete: 'right',
          }}
          isLoadingMore={isLoading}
          noDataMessage={isLoading ? '' : t('settings.pricingIndicesTab.table.emptyMessage')}
        />
      </div>
    </TradingPanel>
  );
}
